const URL = {
    PAYMENT_CONNECTION: 'payment/generateStripeUri',
    PAYMENT_DISCONNECTION: 'payment/disconnectStripeByCardId',
    PAYMENT_PATCH: 'payment/patchPaymentInfo',
    PAYMENT_SESSION: 'payment/CreateStripeSession'
}

export default URL
